export const variables = {
    striped: false
}